// import React, { useState } from 'react'
// import { useHistory } from 'react-router-dom'
// import { toast } from 'react-toastify'
// import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik"
// import * as Yup from "yup"
// import Loader from '../../Components/Loader'
// import masterServices from '../../Services/masterService'

// export const AddPackageMaster = () => {

//     const history = useHistory()
//     const [loader, setLoader] = useState(false)

//     const initialValues = {
//         freight_data: [{
//             package_type: "",
//             rate_per_cmb: "",
//             minimum: '',
//             percentage_fright_mu: ""
//         }]
//     };
//     console.log(history.location.state.data, "history.location.state.datahistory.location.state.data")

//     const validationSchema = Yup.object().shape({
//         freight_data: Yup.array().of(
//             Yup.object().shape({
//                 package_type: Yup.string().required("Required"),
//                 rate_per_cmb: Yup.string().required("Required"),
//                 minimum: Yup.string().required("Required"),
//                 percentage_fright_mu: Yup.string().required("Required")
//             })
//         )
//     });

//     const addNewField = (errors, values, setValues) => {
//         if (values.freight_data != undefined) {
//             let arry = [...values.freight_data]
//             if (errors && errors.freight_data != undefined) {
//                 toast.error("fill initial freight data")
//             } else {
//                 arry.push({
//                     package_type: '',
//                     rate_per_cmb: '',
//                     minimum: '',
//                     percentage_fright_mu: ''
//                 })
//                 setValues({ ...values, freight_data: arry });

//             }
//         }
//     }

//     const onClickRemove = (index, values, setValues) => {
//         let arry = [...values.freight_data]
//         if (index === 0 && values.freight_data.length === (index + 1)) {
//             toast.warning('The initial package is required')
//         } else {
//             arry.splice(index, 1)
//             setValues({ ...values, freight_data: arry });
//         }
//     }

//     const onSubmit = (fields) => {
//         setLoader(true)
//         let postData = {
//             package_type: fields.freight_data.map((item) => item.package_type),
//             rate_per_cmb: fields.freight_data.map((item) => item.rate_per_cmb),
//             minimum: fields.freight_data.map((item) => item.minimum),
//             percentage_fright_mu: fields.freight_data.map((item) => item.percentage_fright_mu),
//             id: history.location.state._id
//         }
//         masterServices.add_package_margin(postData).then(res => {
//             console.log(res, "update==========================")
//             if (res.status) {
//                 history.goBack()
//             } else {
//                 toast.error(res.message)
//             }
//         })
//     }

//     return (
//         <div className="row">
//             <div className="col-lg-12">
//                 <div className="card">
//                     <div className="card-body">
//                         <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
//                             {({ errors, values, touched, setValues }) => (
//                                 <Form className="control-form">
//                                     <div className="row mb-3">
//                                         <div className="col-md-10">
//                                             <div className="row">
//                                                 <div className="col">
//                                                     <label>Packing Type</label>
//                                                 </div>
//                                                 <div className="col">
//                                                     <label>Rate Per CBM</label>
//                                                 </div>
//                                                 <div className="col">
//                                                     <label>Minimum</label>
//                                                 </div>
//                                                 <div className="col">
//                                                     <label>% Freight MU</label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <FieldArray name="freight_data">
//                                         {() => (values.freight_data === undefined ? '' : values.freight_data.map((ticket, i) => {
//                                             const ticketErrors = errors.freight_data?.length && errors.freight_data[i] || {};
//                                             const ticketTouched = touched.freight_data?.length && touched.freight_data[i] || {};
//                                             return (
//                                                 <div className="row">
//                                                     <div className="col-md-10">
//                                                         <div className="row">
//                                                             <div className="col">
//                                                                 <Field
//                                                                     name={`freight_data.${i}.package_type`}
//                                                                     type="text"
//                                                                     classN ame={"form-control" + (ticketErrors.package_type && ticketTouched.package_type ? " is-invalid" : "")}
//                                                                 />
//                                                                 <ErrorMessage name={`freight_data.${i}.package_type`} component="div" className="invalid-feedback" />
//                                                             </div>
//                                                             <div className="col">
//                                                                 <Field
//                                                                     name={`freight_data.${i}.rate_per_cmb`}
//                                                                     type="number"
//                                                                     className={"form-control" + (ticketErrors.rate_per_cmb && ticketTouched.rate_per_cmb ? " is-invalid" : "")}
//                                                                 />
//                                                                 <ErrorMessage name={`freight_data.${i}.rate_per_cmb`} component="div" className="invalid-feedback" />
//                                                             </div>
//                                                             <div className="col">
//                                                                 <Field
//                                                                     name={`freight_data.${i}.percentage_fright_mu`}
//                                                                     type="number"
//                                                                     className={"form-control" + (ticketErrors.percentage_fright_mu && ticketTouched.percentage_fright_mu ? " is-invalid" : "")}
//                                                                 />
//                                                                 <ErrorMessage name={`freight_data.${i}.percentage_fright_mu`} component="div" className="invalid-feedback" />
//                                                             </div>
//                                                             <div className="col">
//                                                                 <Field
//                                                                     name={`freight_data.${i}.minimum`}
//                                                                     type="number"
//                                                                     className={"form-control" + (ticketErrors.minimum && ticketTouched.minimum ? " is-invalid" : "")}
//                                                                 />
//                                                                 <ErrorMessage name={`freight_data.${i}.minimum`} component="div" className="invalid-feedback" />
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col">
//                                                         <button className="btn btn-danger w-100" type="button" onClick={() => onClickRemove(i, values, setValues)}>Remove</button>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <hr className="my-3" />
//                                                     </div>
//                                                 </div>
//                                             );
//                                         }))}
//                                     </FieldArray>

//                                     <p className="text-primary pointer" onClick={() => addNewField(errors, values, setValues)}>+ Add New Package</p>
//                                     <div className="mt-3 d-flex justify-content-between">
//                                         <button
//                                             className="btn btn-danger w-sm waves-effect waves-light"
//                                             type="button"
//                                             onClick={() => history.goBack()}
//                                         >
//                                             Back
//                                         </button>
//                                         <button className="btn btn-primary w-sm waves-effect waves-light"
//                                             type="submit"
//                                         >
//                                             Submit
//                                         </button>
//                                     </div>
//                                 </Form>
//                             )}
//                         </Formik>
//                         <Loader isShow={loader} />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }


import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik"
import * as Yup from "yup"
import Loader from '../../Components/Loader'
import Select from "react-select";
// import masterServices from '../../Services/masterService'
const packingTypeList = [
    { value: " pallet_packing", label: "Pallet Packing " },
    { value: "crate_packing", label: "Crate Packing" },
    { value: "carton_packing", label: "Carton Packing" }


]
export const AddPackageMaster = () => {

    const history = useHistory()
    // eslint-disable-next-line
    const [loader, setLoader] = useState(false)
    const [packingType, setFreightType] = useState()

    const initialValues = {
        // freight_data: history.location.state.data,
        freight_data: [{
            package_type: "",
            rate_per_cmb: "",
            minimum: '',
            percentage_fright_mu: ""
        }]
    };
    // console.log(history.location.state.data, "history.location.state.datahistory.location.state.data")

    const validationSchema = Yup.object().shape({
        freight_data: Yup.array().of(
            Yup.object().shape({
                package_type: Yup.string().required("Required"),
                rate_per_cmb: Yup.string().required("Required"),
                minimum: Yup.string().required("Required"),
                // percentage_fright_mu: Yup.string().required("Required")
            })
        )
    });

    const addNewField = (errors, values, setValues) => {
        console.log(values, "valuesvaluesvalues")
        if (values.freight_data !== undefined) {
            let arry = [...values.freight_data]
            if (errors && errors.freight_data !== undefined) {
                toast.error("fill initial freight data")
            } else {
                arry.push({
                    package_type: '',
                    rate_per_cmb: '',
                    minimum: '',
                    // percentage_fright_mu: ''
                })
                setValues({ ...values, freight_data: arry });

            }
        }
    }

    const onClickRemove = (index, values, setValues) => {
        let arry = [...values.freight_data]
        if (index === 0 && values.freight_data.length === (index + 1)) {
            toast.warning('The initial package is required')
        } else {
            arry.splice(index, 1)
            setValues({ ...values, freight_data: arry });
        }
    }

    const onSelectFreightType = (e, values, setValues) => {
        setFreightType(e)
        console.log(values, 'e, values')
        setValues({ ...values, values: e.value })
    }

    const onSubmit = (fields) => {
        console.log(fields, "postDatapostData")
        // setLoader(true)
        // let postData = {
        //     package_type: fields.freight_data.map((item) => item.package_type),
        //     rate_per_cmb: fields.freight_data.map((item) => item.rate_per_cmb),
        //     minimum: fields.freight_data.map((item) => item.minimum),
        //     percentage_fright_mu: fields.freight_data.map((item) => item.percentage_fright_mu),
        //     id: history.location.state._id
        // }
        // console.log(postData, "postDatapostData")
        // masterServices.add_package_margin(postData).then(res => {
        //     console.log(res, "update==========================")
        //     if (res.status) {
        //         history.goBack()
        //     } else {
        //         toast.error(res.message)
        //     }
        // })
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                            {({ errors, values, touched, setValues }) => (
                                <Form className="control-form">
                                    <div className="row mb-3">
                                        <div className="col-md-10">
                                            <div className="row">
                                                <div className="col">
                                                    <label>Packing Type</label>
                                                </div>
                                                <div className="col">
                                                    <label>Rate Per CBM</label>
                                                </div>
                                                <div className="col">
                                                    <label>Minimum</label>
                                                </div>
                                                {/* <div className="col">
                                                    <label>% Freight MU</label>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <FieldArray name="freight_data">
                                        {() => (values.freight_data === undefined ? '' : values.freight_data.map((ticket, i) => {
                                            const ticketErrors = errors.freight_data?.length ? errors.freight_data[i] : {};
                                            const ticketTouched = touched.freight_data?.length ? touched.freight_data[i] : {};
                                            return (
                                                <div className="row">
                                                    <div className="col-md-10">
                                                        <div className="row">
                                                            <div className="col">
                                                                <Select
                                                                    styles={{
                                                                        valueContainer: (provided) => ({
                                                                            ...provided,
                                                                            height: "calc(2.15rem + 2px)",
                                                                            overflowY: "visible"
                                                                        }),
                                                                        control: (provider) => ({
                                                                            ...provider,
                                                                            borderColor: errors.package_type ? !errors.package_type ? "#34c38f" : "#f46a6a" : "#ced4da",
                                                                            boxShadow: "0 0 0 0px #f46a6a"
                                                                        }),
                                                                        placeholder: (provider) => ({
                                                                            ...provider,
                                                                            color: "#a0b0ca"
                                                                        })
                                                                    }}
                                                                    value={packingType}
                                                                    name={`freight_data.${i}.package_type`}
                                                                    onChange={(e) => onSelectFreightType(e, values, setValues)}
                                                                    options={packingTypeList}
                                                                // className={"form-control" + (ticketErrors.rate_per_cmb && ticketTouched.rate_per_cmb ? " is-invalid" : "")}
                                                                />
                                                                <ErrorMessage name={`freight_data.${i}.package_type`} component="div" className="invalid-feedback" />
                                                            </div>
                                                            <div className="col">
                                                                <Field
                                                                    name={`freight_data.${i}.rate_per_cmb`}
                                                                    type="number"
                                                                    className={"form-control" + (ticketErrors.rate_per_cmb && ticketTouched.rate_per_cmb ? " is-invalid" : "")}
                                                                />
                                                                <ErrorMessage name={`freight_data.${i}.rate_per_cmb`} component="div" className="invalid-feedback" />
                                                            </div>
                                                            {/* <div className="col">
                                                                <Field
                                                                    name={`freight_data.${i}.percentage_fright_mu`}
                                                                    type="number"
                                                                    className={"form-control" + (ticketErrors.percentage_fright_mu && ticketTouched.percentage_fright_mu ? " is-invalid" : "")}
                                                                />
                                                                <ErrorMessage name={`freight_data.${i}.percentage_fright_mu`} component="div" className="invalid-feedback" />
                                                            </div> */}
                                                            <div className="col">
                                                                <Field
                                                                    name={`freight_data.${i}.minimum`}
                                                                    type="number"
                                                                    className={"form-control" + (ticketErrors.minimum && ticketTouched.minimum ? " is-invalid" : "")}
                                                                />
                                                                <ErrorMessage name={`freight_data.${i}.minimum`} component="div" className="invalid-feedback" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <button className="btn btn-danger w-100" type="button" onClick={() => onClickRemove(i, values, setValues)}>Remove</button>
                                                    </div>
                                                    <div className="col-12">
                                                        <hr className="my-3" />
                                                    </div>
                                                </div>
                                            );
                                        }))}
                                    </FieldArray>

                                    <p className="text-primary pointer" onClick={() => addNewField(errors, values, setValues)}>+ Add New Package</p>
                                    <div className="mt-3 d-flex justify-content-between">
                                        <button
                                            className="btn btn-danger w-sm waves-effect waves-light"
                                            type="button"
                                            onClick={() => history.goBack()}
                                        >
                                            Back
                                        </button>
                                        <button className="btn btn-primary w-sm waves-effect waves-light"
                                            type="submit"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}